import Bowser from 'bowser';

const supportsWebGL = (): boolean => {
  const canvas = document.createElement('canvas');
  const gl =
    canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  return !!(gl && gl instanceof WebGLRenderingContext);
};

const checkIfValidBrowser = (): boolean => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isValidBrowser =
    browser.satisfies({
      desktop: {
        // Enabled for development/testing purposes
        chrome: '>=88',
        safari: '>=14',
      },
    }) || false;
  const isValidIOSVersion =
    browser.getOSName() === 'iOS' &&
    Number(browser.getOSVersion().split('.').shift()) >= 13;
  // Android 7 and above is supported
  const isValidAndroidVersion =
    browser.getOSName() === 'Android' &&
    Number(browser.getOSVersion().split('.').shift()) >= 7;
  return (
    (isValidBrowser || isValidIOSVersion || isValidAndroidVersion) &&
    supportsWebGL()
  );
};

export default checkIfValidBrowser;
